exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.scammer-modal .modal-dialog{width:500px}}@media (max-width:768px){.scammer-modal .modal-dialog{width:280px;left:3%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/applications/apply/ScammerModal.css
// module id = 1099
// module chunks = 0